import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function CallbackTabQuery() {
  const { data } = useQuery({
    queryKey: ["callbackTabStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["CallbackTabStats"]>(
        "/api/Reports/CallbackTabStats",
      );
      return response.data;
    },
  });

  return {
    totalCount: data?.totalOpenCallbacks,
    totalReached: data?.totalReachedToday,
    openLeadCount: data?.totalOpenLeads,
  };
}
